import { createSlice } from "@reduxjs/toolkit";

const getAP = JSON.parse(localStorage.getItem("AP"));

const initialState = {
  entityType: "",
  version: "",
  versionDate: "",
  isFirstLogin: null,
  categoryDropdown: [],
  user: {
    auth: false,
    information: {},
    organizationType: "",
    entityType: "",
    organizationId: "",
    orgId: null,
    enterpriseId: null,
    form: {
      username: "",
      password: "",
    },
    redirectUrl: "",
    error: null,
  },
  sidebarData: [],
  sidebar: {
    view: getAP?.view ? getAP?.view : false,
    hoverTimeout: null,
  },
  trigger: {
    filterButton: false,
  },
  activeTab: "ALL",
  modalShow: false,
  loading: false,
  proposalShow: false,
  policyModalShow: false,
  policyEditModalShow: false,
  editShow: false,
  verifyShow: false,
  logoutShow: false,
  triggerRender: false,
  formRendererState: {},
  // validation for custom inputs
  formRendererValidation: {
    date: false,
    select: false,
    numeric: false,
  },
  wrapperClass: "col-md-9",
  filterApplied: false,
  setItemForDelete: null,
  deleteShow: false,
  uploadShow: false,
  uploadAttachmentShow: false,
  downloadShow: false,
  approveShow: false,
  rejectShow: false,
  approveCheckerShow: false,
  rejectCheckerShow: false,
  pagination: {
    totalCount: 0,
    page: 0,
    size: 50,
    loading: false,
    tabs: [],
  },
  loader: {
    skeleton: false,
    workflowSkeleton: false,
    download: false,
    upload: false,
    metaData: false,
  },
  tailSpinLoader: false,
  splitScreenOpen: true,
  userInfo: {},
};

const commonSlice = createSlice({
  name: "common",
  initialState: initialState,
  reducers: {
    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    setVersion(state, action) {
      state.version = action.payload;
    },
    setVersionDate(state, action) {
      state.versionDate = action.payload;
    },
    setCategoryDropdown(state, action) {
      state.categoryDropdown = action.payload;
    },
    changeWrapper(state, action) {
      state.wrapperClass = action.payload;
    },
    setSplitScreen(state, action) {
      switch (action?.payload?.type) {
        case "off":
          state.splitScreenOpen = false;
          break;
        case "on":
          state.splitScreenOpen = true;
          break;
        default:
          state.splitScreenOpen = !state.splitScreenOpen;
      }
    },
    setFilterApplied(state, action) {
      state.filterApplied = action.payload;
    },
    toggleView(state, action) {
      state.sidebar.view = action.payload;
    },
    setHoverTimeout(state, action) {
      state.sidebar.hoverTimeout = action.payload;
    },
    openModal(state, action) {
      state.modalShow = action.payload;
    },
    setLoading(state, action) {
        state.loading = action.payload;
    },
    openProposal(state, action) {
      state.proposalShow = action.payload;
    },
    openPolicyModal(state, action) {
      state.policyModalShow = action.payload;
    },
    editPolicyModal(state, action) {
      state.policyEditModalShow = action.payload;
    },
    verifyModal(state, action) {
      state.verifyShow = action.payload;
    },
    editModal(state, action) {
      state.editShow = action.payload;
    },
    RenderPage(state) {
      state.triggerRender = !state.triggerRender;
    },
    TriggerFilterButtonApi(state) {
      state.trigger.filterButton = !state.trigger.filterButton;
    },
    setRendererFormState(state, action) {
      switch (action.payload.type) {
        case "checkbox":
          const updatedState = {
            ...state,
            formRendererState: {
              ...state.formRendererState,
              [action.payload.name]: action.payload.binary
                ? action.payload.checked
                  ? 0
                  : 1
                : action.payload.checked,
            },
          };
          return updatedState;
        default:
          const key = action.payload.key;
          const value = action.payload.value;

          // if values is "" then remove key from state
          // if (value === "") {
          //   const { [key]: omit, ...newFormRendererState } =
          //     state.formRendererState;
          //   state.formRendererState = newFormRendererState;
          // } else {
          state.formRendererState = {
            ...state.formRendererState,
            [key]: value,
          };
        // };
      }
    },
    resetFormState: (state) => {
      state.formRendererState = {};
    },
    setSelectValidError(state, action) {
      state.formRendererValidation.select = action.payload;
    },
    setDateValidError(state, action) {
      state.formRendererValidation.date = action.payload;
    },
    setNumericValidError(state, action) {
      state.formRendererValidation.numeric = action.payload;
    },

    // updateRendererFormState(state, action) {
    //   state.formRendererState = action.payload;
    // },
    updateRendererFormState(state, action) {
      const newState = { ...action.payload };
      delete newState.created_date;
      delete newState.modified_date;
      delete newState.created_by;
      delete newState.modified_by;
      // delete newState.logo_media_id_name;
      state.formRendererState = newState;
    },
    updateRendererState(state, action) {
      state.formRendererState = action.payload;
    },
    setAuth(state, action) {
      state.user.auth = action.payload;
    },
    setUserInformation(state, action) {
      state.user.information = action.payload;
    },
    setLoginDetails(state, action) {
      state.user.form = {
        ...state.user.form,
        [action.payload.name]: action.payload.value,
      };
    },
    clearLoginDetails(state) {
      state.user.form = {};
    },
    setCredentialError(state, action) {
      state.user.error = action.payload;
    },
    setRedirectUrl(state, action) {
      state.user.redirectUrl = action.payload;
    },
    setItemForDelete(state, action) {
      state.selectedItemForDelete = action.payload;
    },
    openDeleteModal(state, action) {
      state.deleteShow = action.payload;
    },
    openUploadModal(state, action) {
      state.uploadShow = action.payload;
    },
    openDownloadModal(state, action) {
      state.downloadShow = action.payload;
    },
    openApproveModal(state, action) {
      state.approveShow = action.payload;
    },
    openRejectModal(state, action) {
      state.rejectShow = action.payload;
    },
    openCheckerApproveModal(state, action) {
      state.approveCheckerShow = action.payload;
    },
    openCheckerRejectModal(state, action) {
      state.rejectCheckerShow = action.payload;
    },
    setPaginationTotalCount(state, action) {
      state.pagination.totalCount = action.payload;
    },
    setPaginationRowsPerPage(state, action) {
      state.pagination.size = action.payload;
    },
    setPaginationPageNumber(state, action) {
      state.pagination.page = action.payload;
    },
    setTableLoading(state, action) {
      state.pagination.loading = action.payload;
    },
    setTableTabs(state, action) {
      state.pagination.tabs = action.payload;
    },
    openUploadAttachmentModal(state, action) {
      state.uploadAttachmentShow = action.payload;
    },
    startDownloadLoading(state, action) {
      state.loader.download = action.payload;
    },
    startUploadLoading(state, action) {
      state.loader.upload = action.payload;
    },
    startSkeletonLoading(state, action) {
      state.loader.skeleton = action.payload;
    },
    startWorkflowSkeletonLoading(state, action) {
      state.loader.workflowSkeleton = action.payload;
    },
    setTablePagination(state, action) {
      state.table.pagination = action.payload;
    },
    setMetaLoading(state, action) {
      state.loader.metaData = action.payload;
    },
    setOrganizationType(state, action) {
      state.user.organizationType = action.payload;
    },
    setEntityType(state, action) {
      state.user.entityType = action.payload;
    },
    setOrganizationId(state, action) {
      state.user.organizationId = action.payload;
    },
    setOrgId(state, action) {
      state.user.orgId = action.payload;
    },
    setEnterpriseId(state, action) {
      state.user.enterpriseId = action.payload;
    },
    logoutModal(state, action) {
      state.logoutShow = action.payload;
    },
    setTailSpinLoading(state, action) {
      state.tailSpinLoader = action.payload;
    },
    set(state, action) {
      state.sidebar.hoverTimeout = action.payload;
    },
    setSidebarData(state, action) {
      state.sidebarData = action.payload;
    },
    setIsFirstLogin(state, action) {
      state.isFirstLogin = action.payload;
    },
    setUserInfo(state, action) {
      state.userInfo = action.payload;
    },
  },
});
export const {
  setActiveTab,
  setVersion,
  setVersionDate,
  changeWrapper,
  setCategoryDropdown,
  setFilterApplied,
  toggleView,
  setHoverTimeout,
  openModal,
  editModal,
  RenderPage,
  openProposal,
  setRendererFormState,
  resetFormState,
  setSelectValidError,
  setDateValidError,
  setLoading,

  updateRendererFormState,
  setAuth,
  setLoginDetails,
  setCredentialError,
  clearLoginDetails,
  setRedirectUrl,
  setItemForDelete,
  openDeleteModal,
  openUploadModal,
  openDownloadModal,
  openApproveModal,
  openRejectModal,
  openCheckerApproveModal,
  openCheckerRejectModal,
  setPaginationTotalCount,
  setPaginationRowsPerPage,
  setPaginationPageNumber,
  setTableLoading,
  setTableTabs,
  openUploadAttachmentModal,
  startDownloadLoading,
  startUploadLoading,
  startSkeletonLoading,
  setSplitScreen,
  setTablePagination,
  TriggerFilterButtonApi,
  startWorkflowSkeletonLoading,
  setUserInformation,
  setMetaLoading,
  setOrganizationType,
  setOrganizationId,
  setOrgId,
  verifyModal,
  logoutModal,
  setEntityType,
  openPolicyModal,
  editPolicyModal,
  setTailSpinLoading,
  setNumericValidError,
  setEnterpriseId,
  setSidebarData,
  setIsFirstLogin,
  updateRendererState,
  setUserInfo,
} = commonSlice.actions;

export default commonSlice.reducer;
